import script from "./ModalEnviarLista.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEnviarLista.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEnviarLista.vue?vue&type=style&index=0&id=717a54de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717a54de"]])

export default __exports__